module.exports = __webpack_public_path__ + "media/correct.04571eb7.mp3";